import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { AccountState } from '../types'
import { getAccountData, doLogin } from './helpers'

const noAccountConfig = {
  username: null,
  phonenumber: null,
  userId: null,
  role: null,
  shortName: null,
  selectedUser: null,
  twoFactorType: null,
  isAuthenticated: false,
  isLoading: true,
  hasError: false,
}

interface SetAccountPayload {
  username: string
  phonenumber: string
  userId: string
  role: string
  shortName: string
}

const initialState: AccountState = { ...noAccountConfig }

export const accountSlice = createSlice({
  name: 'Account',
  initialState,
  reducers: {
    fetchAccount: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setAccount: (state, action: PayloadAction<SetAccountPayload>) => {
      state.username = action.payload.username
      state.phonenumber = action.payload.phonenumber
      state.userId = action.payload.userId
      state.role = action.payload.role
      state.shortName = action.payload.shortName
      state.selectedUser = action.payload.shortName
      state.isLoading = false
      state.isAuthenticated = true
      state.hasError = false
    },
    logoutAccount: (state) => {
      state.username = null
      state.phonenumber = null
      state.userId = null
      state.role = null
      state.shortName = null
      state.selectedUser = null
      state.isAuthenticated = false
      state.isLoading = false
      state.hasError = false
    },
    fetchAccountFailed: (state) => {
      state.username = null
      state.phonenumber = null
      state.userId = null
      state.role = null
      state.shortName = null
      state.selectedUser = null
      state.isLoading = false
      state.isAuthenticated = false
      state.hasError = true
    },
  },
})

export const fetchAccountData = (accessToken: string) => async (dispatch) => {
  try {
    dispatch(fetchAccount())
    const { username, phonenumber, userId, role, shortName } = await getAccountData(accessToken)
    dispatch(
      setAccount({
        username,
        phonenumber,
        userId,
        role,
        shortName,
      }),
    )
  } catch (error) {
    // localStorage.clear()
    // sessionStorage.clear()
    message.error('Account not found')
    dispatch(fetchAccountFailed())
  }
}

export const authenticateUser = (email: string, password: string) => async (dispatch) => {
  try {
    dispatch(fetchAccount())
    const { access_token: accessToken } = await doLogin(email, password)
    localStorage.setItem('bba-token', accessToken)
    const { username, phonenumber, userId, role, shortName } = await getAccountData(accessToken)

    dispatch(
      setAccount({
        username,
        phonenumber,
        userId,
        role,
        shortName,
      }),
    )
  } catch (error) {
    // localStorage.clear()
    // sessionStorage.clear()
    message.error('Account not found Auth')
    dispatch(fetchAccountFailed())
  }
}

// Actions
export const { fetchAccount, setAccount, logoutAccount, fetchAccountFailed } = accountSlice.actions

export default accountSlice.reducer
